import { useState, useEffect } from 'react';
import NumberFlow from '@number-flow/react';
const getTimeLeft = (targetMs) => {
    const diff = Math.max(0, targetMs - Date.now());
    return {
        days: Math.floor(diff / 86400000),
        hours: Math.floor((diff / 3600000) % 24),
        minutes: Math.floor((diff / 60000) % 60),
        seconds: Math.floor((diff / 1000) % 60),
    };
};
// Live ticking countdown to a target ISO date. Rendered client-side (the drop page only
// renders once data arrives), so Date.now() here causes no hydration mismatch.
export const DropCountdown = ({ target, label = 'Ends in' }) => {
    const targetMs = new Date(target).getTime();
    const [time, setTime] = useState(() => getTimeLeft(targetMs));
    useEffect(() => {
        const timer = setInterval(() => setTime(getTimeLeft(targetMs)), 1000);
        return () => clearInterval(timer);
    }, [targetMs]);
    if (Number.isNaN(targetMs)) {
        return null;
    }
    const units = [
        { value: time.days, label: 'Days' },
        { value: time.hours, label: 'Hrs' },
        { value: time.minutes, label: 'Min' },
        { value: time.seconds, label: 'Sec' },
    ];
    return (<div className="inline-flex max-w-full items-center gap-2 rounded-xl border border-solid border-neon-purple/40 bg-gradient-to-r from-neon-pink/25 via-neon-purple/25 to-neon-cyan/25 bg-[length:200%_100%] px-3 py-2 shadow-[0_0_28px_-6px_var(--primary)] backdrop-blur-md animate-gradient-pan sm:gap-3 sm:px-5 sm:py-2.5">
			<span className="text-xs font-bold uppercase tracking-wider text-foreground">{label}</span>
			<div className="flex items-center gap-1 sm:gap-1.5">
				{units.map((unit, index) => (<div key={unit.label} className="flex items-center gap-1 sm:gap-1.5">
						<div className="flex min-w-[34px] flex-col items-center rounded-lg border border-solid border-white/10 bg-black/45 px-1.5 py-1.5 sm:min-w-[42px] sm:px-2">
							<NumberFlow value={unit.value} format={{ minimumIntegerDigits: 2 }} className="font-display text-sm font-extrabold text-foreground drop-shadow-primary-glow sm:text-base"/>
							<span className="text-[9px] font-semibold uppercase tracking-wide text-muted-foreground">{unit.label}</span>
						</div>
						{index < units.length - 1 && <span className="text-sm font-bold text-neon-purple/70">:</span>}
					</div>))}
			</div>
		</div>);
};
